import memoizeOne from 'memoize-one';
import type { IntlFormatV2 as IntlFormat } from '@atlassian/jira-intl/src/v2/types.tsx';
import type { PaletteColor } from '@atlassian/jira-issue-epic-color-types/src/types.tsx';
import { getDefaultColorPalette } from '@atlassian/jira-issue-epic-color/src/common/utils.tsx';

// This is the same as the ID for the next-gen color field.
export const colorFieldDataTestId = 'issue.views.issue-base.foundation.color.color-picker-wrapper';

export const getI18nColorPalette: (arg1: IntlFormat) => PaletteColor[] = memoizeOne(
	({ formatMessage }) => getDefaultColorPalette(formatMessage),
);
